const disableInputScroll = () => {
  document.addEventListener('wheel', function (_event) {
    if (document.activeElement.type === 'number') {
      document.activeElement.blur()
    }
  })
}

export { disableInputScroll }
